import { variablesFaltantes } from '@/lib/entorno'
import { MarcaMega } from '@/shared/marca/MarcaMega'

import estilos from './PantallaConfiguracion.module.css'

/**
 * Lo que se ve cuando el sistema arranca sin configuración.
 *
 * Reemplaza a la pantalla en blanco. Un `throw` al importar el módulo de
 * entorno sería más corto, pero obliga a abrir la consola del navegador para
 * enterarse de qué pasó; quien está montando el proyecto por primera vez
 * merece que la propia pantalla se lo diga.
 *
 * No es una pantalla de error: es la primera instrucción del sistema.
 */
export function PantallaConfiguracion() {
  return (
    <div className={estilos.pantalla}>
      <main className={estilos.tarjeta}>
        <header className={estilos.cabecera}>
          <MarcaMega fondo="claro" tamanoLogo={46} />

          <div>
            <h1 className={estilos.titulo}>Falta conectar la base de datos</h1>
            <p className={estilos.subtitulo}>
              El sistema está compilado y funcionando; solo le faltan las llaves de Supabase.
            </p>
          </div>
        </header>

        <p style={{ fontSize: 13, color: 'var(--tinta-2)', lineHeight: 1.65 }}>
          {variablesFaltantes.length === 1
            ? 'Hace falta esta variable de entorno:'
            : 'Hacen falta estas variables de entorno:'}
        </p>

        <ul className={estilos.faltantes}>
          {variablesFaltantes.map((variable) => (
            <li key={variable} className={estilos.faltante}>
              <span className={estilos.punto} aria-hidden="true" />
              {variable}
            </li>
          ))}
        </ul>

        <ol className={estilos.pasos}>
          <li>
            En <strong>Supabase</strong>, abra su proyecto y vaya a{' '}
            <strong>Project Settings → API</strong>. Copie la <em>Project URL</em> y la llave{' '}
            <em>anon / public</em>.
          </li>

          <li>
            Cree el archivo <strong>.env</strong> en la raíz del proyecto:
            <code className={estilos.codigo}>
              {'VITE_SUPABASE_URL=https://xxxxxxxx.supabase.co\nVITE_SUPABASE_ANON_KEY=eyJhbGciOi…'}
            </code>
          </li>

          <li>
            Reinicie el servidor de desarrollo. Vite lee el <strong>.env</strong> solo al
            arrancar, así que un guardado no basta.
            <code className={estilos.codigo}>npm run dev</code>
          </li>
        </ol>

        <p className={estilos.nota}>
          La llave <em>anon</em> es pública por diseño y puede viajar al navegador sin riesgo: la
          protección real son las políticas RLS de la base de datos. La que <strong>nunca</strong>{' '}
          va en un archivo <code>VITE_</code> es la <em>service_role</em>, porque todo lo que
          empieza por <code>VITE_</code> queda visible para cualquiera que abra el inspector.
        </p>
      </main>
    </div>
  )
}
